<template>
  <HeaderComponent :flag="1"/>
  <CardView />
  <FooterComponent />
</template>

<script>
import HeaderComponent from "../semantics/HeaderComponent.vue";
import FooterComponent from "../semantics/FooterComponent.vue";
//import profiledetails from "../../assets/profiledetails.json";
import CardView from "../Faculty/CardView.vue";
export default {
  name: "FacultyHome",
  components: {
    HeaderComponent,
    FooterComponent,
    CardView
  }
};
</script>
<style scoped>
.content {
  margin-top: 20px;
}

.icon-refresh {
  vertical-align: top;
}

.terms-card {
  padding: 5px;
  background-color: #f1f9f6d6;
  margin-bottom: 20px;
}

.align-center {
  align-items: center;
}
</style>